import React from 'react';
import { render } from 'react-dom';
import { ready } from 'core-utilities';
import App from './App';
import { rootElementId } from './app.config';

ready(() => {
  render(<App />, document.getElementById(rootElementId));
});
